import { ReactNode, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal, PHONE_VERIFICATION_ACTION, phoneVerification } from '~/actions';
import { Typography } from '@tempmee/react';
import { Center, ConfirmPopup } from '~/commonComponents';
import { VerificationInput } from '~/commonComponents/VerificationInput';
import { useAppSelector, useLoading } from '~/hooks';
import { fireMfaCodeSubmitted, fireMfaPopUpViewed } from '~/posthogs/events';

interface IProps {
  tel: string;
}

export const VerifyPhonePopup = ({ tel }: IProps): ReactNode => {
  const isOpen = useAppSelector((state) => state.user.pendingPhoneVerification);
  const dispatch = useDispatch();
  const { isLoading } = useLoading([PHONE_VERIFICATION_ACTION]);

  const [code, setCode] = useState('');

  const onClosePopup = () => dispatch(closeModal());

  const onSubmit = (code: string) => {
    fireMfaCodeSubmitted();

    dispatch(phoneVerification({ code, phone: tel }));
  };

  useEffect(() => {
    if (isOpen) {
      fireMfaPopUpViewed();
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <ConfirmPopup
      closePopup={onClosePopup}
      dataCy="confirm-phone-number-popup"
      dataTestId="confirm-phone-number-popup"
      dismissiblePopup={false}
      modalContainerStyle={{ zIndex: 'auto' }}
      rightButtonAction={() => onSubmit(code)}
      rightButtonLoading={isLoading}
      rightButtonText="Submit"
      showClosePopupIcon
    >
      <Typography as="span" bold size="heading_3">
        Confirmation Code
      </Typography>
      <Center marginBottom={32} marginTop={60}>
        <Typography as="span" textAlign="center">We sent you a 5 digit confirmation</Typography>
        <Typography as="span" textAlign="center">
          code to <strong>{tel}</strong>
        </Typography>
      </Center>
      <Center marginBottom={56}>
        <VerificationInput
          onChange={setCode}
          onComplete={(e) => {
            onSubmit(e);
          }}
        />
      </Center>
    </ConfirmPopup>
  );
};
